var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lesson"}},[_c('div',{staticClass:"webview"},[_c('iframe',{attrs:{"allow":"microphone *;clipboard-read *; clipboard-write *","src":_vm.test.content_url,"frameborder":"0","allowfullscreen":"","width":"100%","height":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }